<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_result mb-20">
            <article class="srch_basic clear">
                <dl class="dl_search w100p"><!-- 200525수정(검색필드가 하나일때 w100p 클래스 추가) -->
                    <dd class="clearable" data-input-type="input">
                        <input type="text" class="text_input w100p" v-model="modelCode" ref="modelCd" 
                               @keyup="onAutoCmpl" @keyup.enter.stop="onSearch(1)" v-regex="'/[^0-9a-zA-Z\-]/g'"
                               :placeholder="placeHolder" maxLength="20">
                        <i class="clearable_clear">X</i>
                    </dd>
                    <dd class="btn"><a href="javascript:" @click="onSearch(1)" class="btn_srch">{{$t('BUTTON.GLOBAL.SEARCH')}}</a></dd>
                    <dd v-if="searchMode == '1'" class="auto">
                        <!-- search autocomplete -->
                        <article class="srch_more">
                            <dl class="srch_autocomplete">
                                <dd>
                                    <ul class="scroll">
                                        <li v-for="model in autoCompletes" :key="model.ID" :class="{active: model.ID == modelCode}">
                                            <a href="JavaScript:" @click="modelCode = model.ID">{{model.LABEL}}</a>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </article>
                    </dd>
                </dl>
            </article>
        </div>

        <!-- Grid -->
        <div class="grid_wrap">
            <div class="grid_total">Total Count : <em>{{ resultCount | numberFormat }}</em></div>
            <toast-grid
                :gridId="gridId"
                :columns="columns"
                :data="gridData"
                :options="options"
                :ref="gridId"
                :key="gridKey"
                :pageOptions="pageOptions"
                :isTotalCount="false"
                :click="contentClick"
            />
        </div>
        <!-- gridDown_wrap -->
        <div v-if="selModelCd &&  qcdnAttachFiles.length > 0" class="gridDown_wrap">
            <div class="table_modul gridDown_wrap">
                <div class="gridtop_wrap">
                    <em class="txt_info">{{$t('MESSAGE.SEARCH.REQ.EXPLORER')}}</em>
                    <div class="btn_wrap">
                        <a href="http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.cab" class="btn_white" title=""><i class="ico_down"></i>Deju Vu</a>
                        <a href="http://skp.samsungcsportal.com/basis/page/isoview7.cab" class="btn_white" title=""><i class="ico_down"></i>iso View</a>
                    </div>
                </div>
                <table class="data_table_ty2">
                    <colgroup>
                        <col width="25%">
                        <col width="20%">
                        <col width="25%">
                        <col width="*">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>{{$t('FIELD.GLOBAL.MODEL')}}</th>
                            <th>{{$t('FIELD.GLOBAL.VERSION')}}</th>
                            <th class="pc_only">{{$t('FIELD.SEARCH.WEB.VIEW')}}</th>
                            <th>{{$t('FIELD.SEARCH.PDF')}}</th>
                        </tr>
                    </thead>
                    <tbody class="text_center">
                        <tr v-for="file in qcdnAttachFiles" :key="file.VERSION">
                            <td>{{file.MODEL_CD}}</td>
                            <td>{{file.VERSION}}</td>
                            <td class="pc_only">
                                <a href="JavaScript:" @click="popupHtmlOpen2(file)" v-if="file.BOM_FILE_NAME" class="txt_link">{{$t('BUTTON.SEARCH.CLICK')}}</a>
                            </td>
                            <td>
                                <a href="JavaScript:" @click="popupHtmlOpen3(file)" v-if="file.PDF_FILE_NAME" class="txt_link">{{file.PDF_FILE_NAME}}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import _                from 'lodash';
import $                from 'jquery';
import qs               from 'query-string';
import { SDLUtil }      from '@/utils';
import SKPSnb           from '~vb/main/SKPSnb';
import ExpToastGrid     from '~c/ToastGrid';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import { EventBus }     from '@/utils/EventBus';

/* 컴포넌트에서 사용할 스크립트 */
export default {
    name : 'ExplodedModelList',
    props : {
    },
    computed: {
    },
    components: {
        'toast-grid'            : ExpToastGrid,
        'skp-breadcrumbs'       : SKPBreadcrumbs
    },
    data() {
        return {
            modelCode : '',
            selModelCd : '',
            pageTitle : '',
            gridId : 'gridExpModel',
            gridKey: 0,
            placeHolder: SDLUtil.getMsgProp('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH'),
            searchMode: '0',
            cursorIndex: -1,
            currentPage: 1,
            perPage: 3000, // parseInt(localStorage.getItem('listRows') || 10),
            gridData :  [],
            resultCount: 0,
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                    name: 'MODEL_CD',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PROD.DESC'),
                    name: 'PROD_DESC',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PLANT'),
                    name: 'PLANT',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('TITLE.PRODUCT.INFO.EXPLODED.VIEW'),
                    name: 'VIEW_CNT',
                    align: 'center',
                    width: '200',
                    sortable: true
                }
            ],            
            options: {
                scrollY: false,
                scrollX: false,
//                minBodyHeight: 80,
//                bodyHeight: 318,
                rowHeight: 25,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 10, //parseInt(localStorage.getItem('listRows') || 10),
            },
            qcdnAttachFiles: [],
            autoCompletes: [],
            searchParams : {}
        }
    },
    methods: {

        async searchFromServer(pageNo, mode, modelCd) {
            if (!pageNo) pageNo = 1;

            let param = {};
            let url = null;
            if (mode == 1) {
                console.log('', );
                param = {modelCode: this.modelCode, perPage: this.perPage, page: pageNo};
                url = `${SDLUtil.API_URL}/basis/explodedView/explodedModels.skp`;
                this.gridData = [];
            } else if (mode == 2) {
                param = {modelCode: modelCd, perPage: 30, page: 1};
                url = `${SDLUtil.API_URL}/basis/search/getBomPdfFilesByModel.skp`;
            }

            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    if (mode == 1) { // search MainView
                        this.resultCount = resp.data.totalCount;
                        this.gridData = resp.data.rows;
                        console.log('this.gridData => ', this.gridData.length);

                        this.currentPage = pageNo;
                        this.gridKey += 1; // This will re-render grid
                        this.qcdnAttachFiles = [];
                    } else { // search SubView
                        console.log('resp.data ==> ', resp.data);
                        this.qcdnAttachFiles = resp.data;

                    }

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        popupBomOpen(row) {
            // TODO Samsung.com 열기 위한 필수 값이 없을 경우 이벤트 처리 필요
            const url = `${SDLUtil.API_URL}/basis/search/redirectBomView.skp`;
            return axios
                .post(url, qs.stringify({ modelCode: row.BMODEL_ID }), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    SDLUtil.openLegacyWindowPopup({
                        url: resp.data,
                        title: 'SAMSUNG.COM SUPPORTED',
                        w: 850,
                        h: 720
                    });
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        popupHtmlOpen(file) {
            SDLUtil.openLegacyWindowPopup({
                url: 'http://downloadcenter.samsung.com/content/' + file.BOM_PATH,
                title: 'SAMSUNG.COM SUPPORTED',
                w: 850,
                h: 620
            });
        },
        popupHtmlOpen2(file) {
          const that = this;
			    let fileEncTok = file.ENC_TOKEN;
			    let fileSeq = file.ENC_ATTCH_FILE_SEQ;
			    let version = file.VERSION;
			    let contentId = file.CONTENT_ID;
			    let bomVersion = file.BOM_VERSION;
        	let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
          const win = SDLUtil.openLegacyWindowPopup({
              //url: ''+cmnApiBase + '?attachFileSeq='+fileSeq+'&encToken='+fileEncTok+'&model='+this.sModelCode+'&evGubun=TD',
              url: ''+cmnApiBase + '?attachFileSeq='+fileSeq+'&encToken='+fileEncTok+'&version='+version+'&contentId='+contentId+'&bomVersion='+bomVersion+'&model='+this.sModelCode+'&evGubun=EV&pdfGubun=html',
              title: 'SAMSUNG.COM SUPPORTED',
              w: 850,
              h: 620
            });
            
            win.addEventListener('unload',function(event){
            	that.searchFromServer(1, 2, that.selModelCd);
            });
        },
        popupHtmlOpen3(file) {
          const that = this;
			    let fileEncTok = file.ENC_TOKEN;
			    let fileSeq = file.ENC_ATTCH_FILE_SEQ;
			    let version = file.VERSION;
			    let contentId = file.CONTENT_ID;
			    let bomVersion = file.BOM_VERSION;
        	let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
          const win = SDLUtil.openLegacyWindowPopup({
              url: ''+cmnApiBase + '?attachFileSeq='+fileSeq+'&encToken='+fileEncTok+'&version='+version+'&contentId='+contentId+'&bomVersion='+bomVersion+'&model='+this.sModelCode+'&evGubun=EV&pdfGubun=pdf',
              title: 'SAMSUNG.COM SUPPORTED',
              w: 850,
              h: 620
            });
            
            win.addEventListener('unload',function(event){
            	that.searchFromServer(1, 2, that.selModelCd);
            });
        },
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;

            let item = this.gridData[event.rowKey];
            this.selModelCd = item.MODEL_CD;
            console.log('this.selModelCd ===> ', this.selModelCd);
            this.searchFromServer(1, 2, item.MODEL_CD);
        },
        async execServer(url, param) {
            return await axios.post(url, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    console.log('saved recent model.');
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        onSearch(page) {
            if (this.modelCode.trim().length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                return true;
            }

            // 일단, 최근 검색어 등록
            const url = `${SDLUtil.API_URL}/basis/search/saveRecentModel.skp`;
            this.execServer(url, {searchKind: 'C', keyword : this.modelCode});

            this.searchMode = '0';
            this.searchFromServer(page, 1);
        },
        async onAutoComplete() {
            const param = { keyword: this.modelCode };
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/search/getAutoComplete.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.autoCompletes = resp.data;
                    this.$refs.modelCd.focus();
                })
                .catch(err => {
                    console.log('Err.onAutoComplete ======> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        onAutoCmpl(event) {
            if (event.key == 'Enter' || event.key == 'Escape') return;

            // 상하 화살표 키
            if (event.key == 'ArrowUp' || event.key == 'ArrowDown') { // 위 화살표
                if (event.key == 'ArrowUp') this.cursorIndex -= 1;
                if (event.key == 'ArrowDown') this.cursorIndex += 1;

                if (this.cursorIndex < 0) {
                    this.cursorIndex = this.autoCompletes.length - 1;
                }

                if (this.cursorIndex >= this.autoCompletes.length) this.cursorIndex = 0;
                if (this.autoCompletes.length > 0) this.modelCode = this.autoCompletes[this.cursorIndex].ID;

                return;
            }

            this.modelCode = this.modelCode.toUpperCase();

            if (this.modelCode.length > 2) { // 3자 이상이면...
                this.onAutoComplete();
                this.searchMode = '1';
            }
        },
        // 모델코드 선택
        handleSelectModel(model = '') {
            this.modelCode = model;
        },
    },
    created() {
        EventBus.$on('select-recent-model', model => { this.handleSelectModel(model); });
    },
    mounted() {
//        this.$refs.modelCd.focus();
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
//        EventBus.$off('knowledge-page-search');
        EventBus.$off('select-recent-model');
    }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/explodedView/ExplodedModelList.vue